import React, { useEffect, useState } from 'react';
import { deleteDocumentsType, getDocumentsType, } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import '../../../Utility/pagination.css'
import { EditDocumentType } from './form';
import { Deletemodel, Pagination } from "../../Common/Functions"
const Documents_type = () => {

    const [documentyType, setDocumentsType] = useState([]);
    const [formData, setFormData] = useState({ title: '', status: '' });

    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const [addoredit, setaddoredit] = useState();
    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const rolesPerPage = 10; // Number of roles per page

    useEffect(() => {
        fetchDocumentsType();
    }, []);

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);

    }

    const fetchDocumentsType = async (page = 1, text = "") => {
        try {
            const response = await getDocumentsType(page, text);
            if (response.data && response.data.data) {
                setDocumentsType(response.data.data);
                setTotalPages(response.data.pagination.total_pages); // Update total pages for pagination

            }
        } catch (error) {
            console.error('Error fetching Documents Type  data:', error);
        }
    };



    const openAddModal = () => {
        setaddoredit(true)
        setShowEditModal(!showEditModal)
    }
    const openEditModal = (cat) => {
        setSelectedDocumentType(cat);
        setaddoredit(false)
        setShowEditModal(!showEditModal)
    }




    useEffect(() => {
        console.log('data', formData)
    }, [formData])


    // Delete a category
    const handleDelete = async () => {
        try {
            await deleteDocumentsType(deleteID);
            toast.success('Documents Type deleted successfully');
            fetchDocumentsType();
            showDeletemodel(false);
        } catch (error) {
            console.error('Error deleting Documents Type:', error);
            toast.error('Error deleting Documents Type');
        }
    };


    // Pagination logic
    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchDocumentsType(pageNumber);
    };

    const handleSearch = async (text) => {
        fetchDocumentsType(1, text);

    }




    return (
        <div className="page-wrappers">
            <div className="page-content">
                <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>Documents Type List</h6>
                <hr />
                <button
                    type="button"
                    onClick={() => openAddModal()}
                    className="btn btn-primary mb-2 text-normal rounded-1"
                >
                    Add Documents Type
                </button>

                <div className="card">
                    <div className="card-body">
                        <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                            <div className="d-flex position-relative" style={{ width: "100%" }}>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search..."
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                                <img
                                    src="/assets/images/icons/search.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        height: "18px",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                id="example"
                                className="table table-striped  table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>title</th>
                                        {/* <th>Status</th> */}
                                        {/* <th>CD</th>
                                         <th>UD</th> */}
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {documentyType.map((cat, index) => (
                                        <tr key={cat.id}>
                                            <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                                            <td>{cat.title}</td>
                                            {/* <td>{cat.status === '1' ? 'Active' : 'Inactive'}</td> */}
                                            {/* <td>{new Date(cat.create_date).toLocaleDateString()}</td>
                                            <td>{new Date(cat.update_date).toLocaleDateString()}</td> */}
                                            <td>
                                                <img src='/assets/images/icons/edit.png' onClick={() => openEditModal(cat)} height={"16px"} />
                                                &nbsp;&nbsp;&nbsp;
                                                <img src='/assets/images/icons/delete.png' className="mx" onClick={() => handledeletemodel(cat.id)} height={"16px"} />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>
                            <Pagination 
        currentPage={currentPage} 
        totalPages={totalPages} 
        onPageChange={handlePageChange} 
      />
                        </div>
                    </div>
                </div>
            </div>
            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )};




            <EditDocumentType showModal={showEditModal} setShowModal={() => openEditModal()} fetchDocumentType={() => fetchDocumentsType()} selectedDocumentType={selectedDocumentType} AddorEdit={addoredit} />
        </div>
    )
}

export default Documents_type;